var render, staticRenderFns
import script from "./accessCommon.vue?vue&type=script&lang=js"
export * from "./accessCommon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1497a6d3')) {
      api.createRecord('1497a6d3', component.options)
    } else {
      api.reload('1497a6d3', component.options)
    }
    
  }
}
component.options.__file = "src/components/user/accessCommon.vue"
export default component.exports